import { Avatar, Badge, Button } from "@material-tailwind/react"
import React from "react"
import { WBLabel } from "../WBLabel"
import logo from "../../../assets/logo.png"
import { FaPhone, FaWhatsapp } from "react-icons/fa6"

function AgentInfo ({
    avatar,
    name,
    phoneNumber,
    whatsapp
}) {
    return (
        <div>
            <div className="flex items-center gap-4">
                <Badge placement="top-start" overlap="circular" color="green" withBorder>
                    <Avatar src={avatar ? avatar : logo} alt={name}
                        withBorder={true}
                        className="p-0.5"
                    />
                </Badge>
                <div className="flex-auto">
                    <WBLabel size={16} bold text={name}/>
                    <WBLabel text={"Agent"}/>
                </div>
                <div className="w-[60px] text-right border-l">
                    {
                        phoneNumber &&
                        <div className="flex justify-center border-b p-2 pt-0" onClick={() => {
                            let outsideLink = document.createElement('a');
                            outsideLink.target= '_blank';
                            outsideLink.href= `tel:${phoneNumber}`;
                            outsideLink.click();
                        }}>
                            <FaPhone color="#08348b" size={20}/>
                        </div>
                    }
                    {
                        whatsapp &&
                        <div className="flex justify-center p-2 pb-0" onClick={() => {
                            let outsideLink = document.createElement('a');
                            outsideLink.target= '_blank';
                            outsideLink.href= `https://api.whatsapp.com/send?phone=${whatsapp}`;
                            outsideLink.click();
                        }}>
                            <FaWhatsapp color="#25d366" size={25}/>
                        </div>
                    }
                </div>
            </div>
        </div>
    )
}

export default AgentInfo